import Button from '@material-ui/core/Button';
import { navigateBookDemoClick } from 'common/utils/utils';
import Text from 'components/base/Text';
import { Flex, Margin } from 'components/base/layout-components';
import Egyptians from 'images/characters/egyptians.svg';
import styled from 'styled-components';

const Wrapper = styled(Flex)`
  padding: 2rem;
`;
const DataRetentionModal = ({ retentionDays, onBackToCurrentIteration }) => {
  return (
    <Wrapper direction='column'>
      <img src={Egyptians} alt='' />
      <Text pt='2rem' size='x-x-large' weight='300'>
        Unlock past iterations
      </Text>
      <Text pb='2rem' pt='2rem' color='shark' size='medium'>
        Your license provides you with {retentionDays} days of metrics history.
        Upgrade your plan to go back in time.
      </Text>
      <Flex direction='row-reverse'>
        <Button onClick={navigateBookDemoClick} variant='contained'>
          Learn more
        </Button>
        <Margin r='small' />
        <Button onClick={onBackToCurrentIteration} variant='outlined'>
          Back to current iteration
        </Button>
      </Flex>
    </Wrapper>
  );
};

export default DataRetentionModal;
